module.exports = __webpack_public_path__ + "static/img/DC_Comics-Selected.36ec36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/DC_Comics-Selected.png
// module id = 598
// module chunks = 0